/**
 * Derive Fuel £/mi from UK imperial MPG and Keyfuels diesel PPL.
 *
 * £/mi = (pence_per_litre / 100) × (litres_per_UK_gallon / MPG)
 *
 * PPL is price only; MPG is consumption. Uploaded fuel price alone never sets £/mi.
 */

/** Imperial gallon → litres (UK). */
export const LITRES_PER_UK_GALLON = 4.54609;

/** Round £/mi for Running cost tables (4 dp). */
export function roundFuelGbpPerMile(n: number): number {
  return Math.round(n * 10_000) / 10_000;
}

/**
 * Convert MPG + PPL (pence) → fuel £ per mile.
 * Returns null when inputs are non-finite or non-positive.
 */
export function gbpPerMileFromMpgAndPpl(
  mpg: number,
  pencePerLitre: number,
): number | null {
  if (!Number.isFinite(mpg) || mpg <= 0) return null;
  if (!Number.isFinite(pencePerLitre) || pencePerLitre <= 0) return null;
  const gbpPerLitre = pencePerLitre / 100;
  const litresPerMile = LITRES_PER_UK_GALLON / mpg;
  return roundFuelGbpPerMile(gbpPerLitre * litresPerMile);
}
